import React from "react";
import NavBar from "../components/ui/navbar";
import Table from "../components/ui/table";
import Chart from "../components/ui/chart";
import { Box } from "@chakra-ui/react";

function Page({ data }: { data: any }) {
  return (
    <>
      <NavBar data={data} selected="league" />
      <Box w="full" h="calc(50vh - 60px)">
        <Chart
          plotData={getPlotlyData(data.fundPerfData, data.dataDate)}
          title="Team Portfolio Values"
          yaxis="Value (£)"
        />
      </Box>
      <Box w="full" h="calc(50vh)">
        <h1>League Table</h1>
        <Table
          columnDefs={data.leagueTable.cols}
          tableData={data.leagueTable.items}
        />
      </Box>
    </>
  );
}

function getPlotlyData(data: any, dataDate: string) {
  var plotly: any[] = [];
  data.map((s: any) => {
    //let x = Array.from({ length: s.PercPerfs.length }, (e, i) => i);
    let x = buildDates(dataDate, s.PercPerfs.length);
    plotly.push({
      x: x,
      y: Array.from(s.PercPerfs, (v: any) => (v / 100 + 1) * 5000000),
      type: "scatter",
      mode: "lines",
      name: s.Name,
    });
  });
  return plotly;
}

function buildDates(baseDate: string, itemCount: number) {
  const date = new Date(baseDate);
  var day = date.getDay();
  //let x = Array.from({ length: s.PercPerfs.length }, (e, i) => i);
  var x: Date[] = [];
  for (let i = 0; i < itemCount; i++) {
    if (day === 0) {
      date.setDate(date.getDate() - 2);
      day = 5;
    }
    x.push(new Date(date));
    date.setDate(date.getDate() - 1);
    day -= 1;
  }
  return x;
}

export default Page;
